export enum CapacityType {
  DEFAULT,
  SEASONAL
}
